<template>
	<div class="display-flex height-100">
		<div class="form-container text-left width-100 height-100" @click="sideBarFocus = 'form'">
			<NotificationPreview :notification="notification" />
		</div>

		<div v-if="hasEditPermissions" class="right-bar is-open">
			<div class="display-flex flex-column pa-3">
				<div class="header-container display-flex flex-row flex-align-center flex-justify-space-between">
					<div class="header-title my-1">Notification</div>
				</div>
				<NotificationSettings />
			</div>
		</div>
	</div>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { notification } from '@/store/modules/selectedNode/getters';
import NotificationSettings from '@/components/BlockEditorNotification/NotificationSettings.vue';
import NotificationPreview from '@/components/BlockEditorNotification/NotificationPreview.vue';

export default {
	name: 'NotificationEditorBody',
	props: {
		hasEditPermissions: { type: Boolean },
	},
	components: {
		NotificationSettings,
		NotificationPreview,
	},
	computed: {
		...mapGettersShorthand({ notification }),
	},
};
</script>

<style scoped lang="scss">
.form-container {
	height: 100%;
	padding: 10px 20px 120px 20px;
	background: var(--bg-color);
	z-index: 1;
	max-width: 590px;

	::v-deep .block-editor-widget-layout-new {
		transition: 0.3s;
	}
}
.right-bar {
	z-index: 2;
	max-width: var(--widget-field-settings-editor);
	min-width: var(--widget-field-settings-editor);
	position: relative;
	border-left: 1px solid #e7e7ed;
	background: var(--bg-color) !important;
}

.header-title {
	color: #161b42;
	font-weight: 700 !important;
}
</style>
